import { motion } from "framer-motion";
import { Check } from "lucide-react";
import { Reveal } from "./Reveal";

const points = [
  "One-stop management — venue to Vidai",
  "In-house pure-veg catering (Arihant Caterers)",
  "Bespoke decor, floral & stage design",
  "Pan-India destination weddings",
];

export default function About() {
  return (
    <section id="about" data-testid="about-section" className="bg-heirloom-bone py-24 md:py-28">
      <div className="max-w-[1300px] mx-auto px-6 grid grid-cols-1 lg:grid-cols-2 gap-14 lg:gap-20 items-center">
        {/* images */}
        <div className="relative">
          <div className="relative overflow-hidden rounded-2xl">
            <img src="/gallery/team.png" alt="Team Arihant Events with Abhishek Jain" className="w-full h-[440px] md:h-[540px] object-cover object-top" />
          </div>
          <div className="absolute -bottom-6 -right-4 md:-right-8 h-32 w-32 md:h-40 md:w-40 bg-heirloom-maroon text-heirloom-bone rounded-2xl flex flex-col items-center justify-center shadow-2xl">
            <span className="font-display text-4xl md:text-5xl font-bold text-heirloom-gold-light">15+</span>
            <span className="overline text-[0.55rem] mt-1 text-center leading-tight">Years of<br/>Experience</span>
          </div>
          <div className="hidden md:block absolute -top-6 -left-6 h-24 w-24 rounded-2xl overflow-hidden border-4 border-heirloom-bone shadow-xl">
            <img src="https://images.pexels.com/photos/34321387/pexels-photo-34321387.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=200&w=200" alt="catering" className="w-full h-full object-cover" />
          </div>
        </div>

        {/* text */}
        <div>
          <Reveal>
            <span className="gold-rule overline text-heirloom-maroon">About Us</span>
            <h2 className="font-display text-4xl md:text-5xl leading-tight text-heirloom-obsidian mt-5">
              Arihant Events — Indore&rsquo;s Trusted Name in <span className="text-heirloom-maroon italic">Royal Celebrations</span>
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="text-heirloom-obsidian/70 mt-6 leading-relaxed">
              <span className="font-semibold text-heirloom-obsidian">Mr. Abhishek Jain</span> is the Founder &amp; CEO of
              Arihant Event Management Services. He established the firm around 2009&ndash;2011 and has grown it into one
              of Central India&rsquo;s most trusted names for end-to-end management of major celebrations &mdash; from
              grand weddings to large-scale corporate events.
            </p>
            <p className="text-heirloom-obsidian/70 mt-4 leading-relaxed">
              Under his leadership, the company delivers complete wedding planning, corporate exhibitions, trade fairs,
              auto expos, custom stall design and event lighting. He also oversees <span className="italic">Arihant Caters</span>,
              providing premium large-scale event catering across Madhya Pradesh. Beyond Arihant, he is the Founder, Director
              &amp; CEO of <span className="italic">Simcha Island by Crafted Celebration</span> &mdash; a leading recreational,
              resort &amp; adventure destination near Indore.
            </p>
          </Reveal>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-4 mt-8">
            {points.map((p, i) => (
              <motion.div key={p} initial={{ opacity: 0, x: -16 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.08 }} className="flex items-start gap-3">
                <span className="mt-0.5 h-5 w-5 rounded-full bg-heirloom-maroon text-heirloom-bone flex items-center justify-center shrink-0"><Check size={12} /></span>
                <span className="text-sm text-heirloom-obsidian/80">{p}</span>
              </motion.div>
            ))}
          </div>
          <Reveal delay={0.2} className="flex flex-wrap items-center gap-6 mt-10">
            <button data-testid="about-cta" onClick={() => document.querySelector("#inquiry")?.scrollIntoView({ behavior: "smooth" })} className="bg-heirloom-maroon text-heirloom-bone text-xs font-semibold tracking-[0.16em] uppercase px-8 py-4 rounded-full hover:bg-heirloom-maroon-deep transition-colors duration-300">
              Plan Your Event
            </button>
            <div className="flex items-center gap-3">
              <img src="/gallery/team.png" alt="Abhishek Jain and Team Arihant Events" className="h-12 w-12 rounded-full object-cover object-top border-2 border-heirloom-gold" />
              <div>
                <div className="font-display text-lg text-heirloom-obsidian leading-none">Abhishek Jain</div>
                <div className="text-xs text-heirloom-obsidian/55 mt-1">Founder &amp; CEO</div>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
